import React from 'react';
import PropTypes from 'prop-types';
import Editor from '@monaco-editor/react';

export function CodingGameEditor(props) {

    return (
        <Editor
            height="40vh"
            defaultLanguage="java"
            defaultValue={props.data}
            onChange={(value, event) => { props.onChange(event, value); }}
            theme="vs-dark"
            options={{
                selectOnLineNumbers: true,
                minimap: { enabled: true },
            }}
        />
    );

}

CodingGameEditor.propTypes = {
    onChange: PropTypes.func,
    data: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool
};

export default CodingGameEditor;
